<template>
  <a-layout>
    <a-layout-header class="header" :theme="navTheme" style="padding: 0;position: fixed;width: 100%;top: 0;z-index: 999;">
      <a-menu :theme="navTheme" mode="horizontal" v-model="activePageIndex" :style="{ lineHeight: '64px' }">
        <a-menu-item :key="0" style="float: left; padding: 0 24px;">
          <a href="/">
            <img src="~@/assets/guaz.png" class="logo" alt="logo" style="width: 45px">
            <span class="title">&nbsp;&nbsp;永登县5G+工业智联惠企平台</span>
          </a>
        </a-menu-item>
        <a-menu-item :key="1" @click="toRoute('/home')">首页</a-menu-item>
        <a-menu-item :key="2" @click="toRoute('/searchDemand')">需求大厅</a-menu-item>
        <a-menu-item :key="3" @click="toRoute('/searchPolicy')">政策大厅</a-menu-item>
        <a-menu-item :key="4" @click="toRoute('/ProductCenter')">产品中心</a-menu-item>
        <a-menu-item :key="5" @click="toRoute('/EnterpriseCenter')">服务商库</a-menu-item>
        <a-menu-item :key="6" @click="toRoute('/PlatformCenter')">平台简介</a-menu-item>
        <a-menu-item :key="7" @click="toRoute('/SpecialtyCenter')">特色专区</a-menu-item>
        <a-menu-item :key="8" style="float: right;font-size: 14px;">
          <a href="#" @click="openLogin()" v-if="!ifLogin">登录</a>
          <!-- <a href="#" @click="toBackHome()" v-if="ifLogin">后台</a> -->
          <a-dropdown v-if="ifLogin" placement="bottomRight" :trigger="['click']">
            <span class='action action-full ant-dropdown-link user-dropdown-menu'>
              <a-avatar class='avatar' size='small' :src='getAvatar()' />
              <span v-if='isDesktop()'>欢迎您，{{ nickname() }}</span>
            </span>
            <a-menu slot='overlay' class='user-dropdown-menu-wrapper'>
              <a-menu-item key='0'>
                <a href="javascript:;" @click="toBackHome">
                  <a-icon type='user' class="icon" />
                  <span>个人中心</span>
                </a>
              </a-menu-item>
              <a-menu-item key="1">
                <a href="javascript:;" @click="handleLogout">
                  <a-icon type="logout" class="icon" />
                  <span>退出登录</span>
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-menu-item>
      </a-menu>
    </a-layout-header>

    <a-layout-content style="margin-top: 64px;" v-if="showDetail">
      <div id="userLayout" :class="['user-layout-wrapper', device]">
        <div class="container">
          <route-view v-if="reloadFlag"></route-view>
          <div class="footer">
            <div class="links">
            </div>
            <div class="copyright">
            </div>
          </div>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer style="padding:0;opacity: 0.8;
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.5);background-color: black;">
      <AboutUs></AboutUs>
    </a-layout-footer>

    <a-modal v-model="showLogin" title="" centered @ok="loginSuccess" :footer="null">
      <Login></Login>
    </a-modal>
  </a-layout>
</template>

<script>
import RouteView from "@/components/RouteView"
import AboutUs from "@/components/AboutUs"
import { mixin, mixinDevice } from '@/utils/mixin.js'
import Login from '@/views/login/Login.vue'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getFileAccessHttpUrl, getAction } from '@/api/manage'
import { mapActions, mapGetters, mapState } from 'vuex'
import { getEncryptedString } from '@/utils/encryption/aesEncrypt'
import store from '@/store'
import { triggerWindowResizeEvent } from '@/utils/util'

export default {
  name: "UserLayout",
  components: { RouteView, Login, AboutUs },
  mixins: [mixin, mixinDevice],
  data() {
    return {
      reloadFlag: true,
      showDetail: true,
      showLogin: false,
      ifLogin: false,
      activePage: '',
      activePageIndex: [1],
      pageList: [
        {
          name: 'home',
          path: '/home',
          fullPath: '/home',
          meta: {
            title: '首页'
          }
        },
        {
          name: 'searchDemand',
          path: '/searchDemand',
          fullPath: '/searchDemand',
          meta: {
            title: '需求大厅'
          }
        },
        {
          name: 'searchPolicy',
          path: '/searchPolicy',
          fullPath: '/searchPolicy',
          meta: {
            title: '政策大厅'
          }
        },
        {
          name: 'ProductCenter',
          path: '/ProductCenter',
          fullPath: '/ProductCenter',
          meta: {
            title: '产品中心'
          }
        },
        {
          name: 'EnterpriseCenter',
          path: '/EnterpriseCenter',
          fullPath: '/EnterpriseCenter',
          meta: {
            title: '服务商库'
          }
        },
        {
          name: 'PlatformCenter',
          path: '/PlatformCenter',
          fullPath: '/PlatformCenter',
          meta: {
            title: '平台简介'
          }
        },
        {
          name: 'SpecialtyCenter',
          path: '/SpecialtyCenter',
          fullPath: '/SpecialtyCenter',
          meta: {
            title: '特色专区'
          }
        },
      ],
      linkList: ['/home', '/searchDemand', '/searchPolicy', '/ProductCenter', '/EnterpriseCenter', '/PlatformCenter', '/SpecialtyCenter'],
    }
  },
  mounted() {
    document.body.classList.add('userLayout')
  },
  created() {
    let currentRoute = Object.assign({}, this.$route)
    let index = this.linkList.lastIndexOf(currentRoute.fullPath)
    this.activePageIndex = [(index + 1)];
    let token = Vue.ls.get(ACCESS_TOKEN);
    let that = this;
    if (token) {
      getEncryptedString().then((data) => {
        store.dispatch('CheckLogin').then((response) => {
          if (response.success) {
            that.showLogin = false;
            that.ifLogin = true;
          } else {
            that.ifLogin = false;
          }
        })
      })
    }
  },
  watch: {
    // 'reloadFlag': function (name) {
    //   console.log(",,,,,,,,,,,,,,,,ffff2222,,,",name)

    // },
    '$route.fullPath'(newPath, oldPath) {
      // 当路由的 fullPath 发生变化时,滚动到顶部
      this.$parent.$el.scrollTop=0
    }
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    getAvatar() {
      return getFileAccessHttpUrl(this.avatar())
    },
    toggle() {
      triggerWindowResizeEvent()
    },
    loginSuccess() {
      this.showLogin = false;
      this.ifLogin = true;
    },
    routeReload() {
      this.reloadFlag = false
      let ToggleMultipage = "ToggleMultipage"
      this.$store.dispatch(ToggleMultipage, false)
      this.$nextTick(() => {
        this.$store.dispatch(ToggleMultipage, true)
        this.reloadFlag = true
      })
    },
    handleLogout() {
      const that = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that.Logout({}).then(() => {
            // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
            //update-begin-author:qjh date: 2023-02-21 10:03:12 for: 修改退出重新刷新
            // that.$router.push({ path: '/user/login' });
            window.location.reload();
            //update-end-author:qjh date: 2023-02-21 10:03:12 for:修改退出重新刷新
            // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel() {
        }
      })
    },
    openLogin() {
      this.showLogin = true;
    },
    changeTitle(title) {
      document.title = title
    },
    toRoute(name) {
      if (name == this.$route.fullPath) {
        this.routeReload();
      } else {
        this.activePage = name;
        let index = this.linkList.lastIndexOf(name)
        let waitRouter = this.pageList[index]
        // 【TESTA-523】修复：不允许重复跳转路由异常
        if (waitRouter.fullPath !== this.$route.fullPath) {
          this.$router.push(Object.assign({}, waitRouter))
        }
        this.changeTitle(waitRouter.meta.title)
      }
    },
    toBackHome() {
      let token = Vue.ls.get(ACCESS_TOKEN)
      // 确保token是URL安全的
      const encodedToken = encodeURIComponent(token);
      // 构建包含token的URL
      const url = window._CONFIG['casPrefixUrl'] + `?token=${encodedToken}`;
      // 打开新页面
      window.location.href = url;

    }

  }
}
</script>

<style scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  overflow: auto;
}

/* /deep/ .ant-select-selection {
  background-color: inherit;
  border: 0;
  border-bottom: 1px solid white;
} */

#userLayout .user-layout-wrapper .container {
  width: 100%;
  min-height: 100%;
  background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
  background-size: 100%;
  padding: 110px 0 144px;
  text-align: left;
}

/deep/ .ant-menu-dark .ant-menu-item,
.ant-menu-dark .ant-menu-item-group-title,
.ant-menu-dark .ant-menu-item>a {
  color: rgba(255, 255, 255, 0.65);
  font-size: 16px;
}

#userLayout a {
  text-decoration: none;
}

#userLayout .top {
  text-align: center;
}

#userLayout .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;
}

#userLayout .copyright {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.title {
  color: #fff;
}

.action-full {
  height: 100%;
}

.action {
  cursor: pointer;
  padding: 0px;
  display: inline-block;
  transition: all .3s;
  height: 70%;
  line-height: 46px;
}

.avatar {
  margin: 20px 10px 20px 0;
  color: #1890ff;
  background: hsla(0, 0%, 100%, .85);
  vertical-align: middle;
}

.icon {
  font-size: 16px;
  padding: 4px;
}
</style>